<template>
  <div class="music-uploader">
    <el-upload
      class="upload-demo"
      drag
      multiple
      action="#"
      :http-request="handleHttpRequest"
      :show-file-list="false"
      :on-error="onError"
      :limit="maxFiles"
      :on-exceed="onExceed"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">拖拽多个音频文件或点击上传</div>
      <!-- <div class="el-upload__tip" slot="tip">
        支持删除、清空，最多 {{ maxFiles }} 个
      </div> -->
    </el-upload>
  </div>
</template>

<script>
import { parseBlob } from "music-metadata-browser";
export default {
  name: "MusicUploader", // 组件名
  props: {
    maxFiles: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      files: [],
    };
  },
  methods: {
    async handleHttpRequest({ file }) {
      console.log(file);
      // console.log(this.files.length);
      if (!file.type.startsWith("audio/")) {
        this.$message.warning(`文件 ${file.name} 不是音频类型，已跳过`);
        return false;
      }

      if (this.files.length >= this.maxFiles) {
        this.$message.warning("已达到最大上传数量限制");
        return false;
      }

      try {
        const blob = new Blob([file]);
        const meta = await parseBlob(blob);
        const audioSrc = URL.createObjectURL(file);
        if (meta.common.picture) {
          const dataArr = meta.common.picture[0].data;
          var data = new Blob([dataArr], { type: "image/png" });
          // blob对象转File对象
          const files = new window.File([data], "图片", { type: data.type });
          // console.log("封面图文件", files);
          const reader = new FileReader();
          reader.onload = (e) => {
            const imageSrc = e.target.result; // 读取完成，赋值给src属性显示图片

            this.files.push({
              name: file.name.split(".")[0],
              format: file.name.split(".")[1],
              meta,
              audioSrc,
              imageSrc,
            });
            this.$emit("uploadFile", this.files);
          };
          reader.readAsDataURL(files); // 读取文件内容作为DataURL
        } else {
          this.files.push({
            name: file.name.split(".")[0],
            format: file.name.split(".")[1],
            meta,
            audioSrc,
            imageSrc: "",
          });
          this.$emit("uploadFile", this.files);
        }
      } catch (err) {
        console.error(`解析 ${file.name} 失败：`, err);
        this.$message.error(`文件 ${file.name} 解析失败`);
      }

      return false;
    },
    onError(err, file, fileList) {
      console.log(err, file, fileList);
    },
    onExceed(files) {
      const number = this.maxFiles - this.files.length;
      // console.log(number - 1, files);
      const arr = Array.from(files).splice(0, number);
      // console.log(arr);
      this.$message.error(`音频文件上传限制最大${this.maxFiles}个`);
      if (arr.length === 0) return;
      arr.map((el) => {
        this.handleHttpRequest({ file: el });
      });
    },
    removeFile(index) {
      const removed = this.files.splice(index, 1)[0];
      URL.revokeObjectURL(removed.audioSrc);
    },
    clearAll() {
      this.files.forEach((f) => URL.revokeObjectURL(f.audioSrc));
      this.files = [];
      // this.$message.success("已清空全部音频文件");
    },
  },
};
</script>

<style scoped lang="scss">
.music-uploader {
  position: relative;
  .upload-demo {
    border-radius: 6px;
    .el-upload__tip {
      margin-left: 80px;
    }
  }
}
</style>
